import moment from "moment";
import { useSearchParams } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

import ActionModal from "../ActionModal";
import { ClientAccessControl } from "@careinfo/permission-required";
const NotificationList = (props: any) => {
  const { handleRead, handleDelete } = props;
  const [searchParams, setSearchParms] = useSearchParams({ page: "0" });

  const handleNavigate = (row: any) => {
    const data = row?.original;
    data?.target_content_type === "Pickup Request" ||
    data?.target_content_type === "pickup-request"
      ? window.location.replace(
          `/pickup-request#/edit/${data?.target_object_id}`
        )
      : data?.target_content_type === "Ticket"
      ? window.location.replace(`/support/ticket#/`)
      : data?.target_content_type === "Remarks"
      ? window.location.replace(
          `/order#/?selectedItem=${data?.target_object_id}`
        )
      : "";
  };

  const defaultColumns: any = [
    {
      header: "Title",
      accessorKey: "title",
      cell: ({ row, getValue }) => {
        return (
          <button
            onClick={() => handleNavigate(row)}
            className={tw`focus:outline-none`}
          >
            {getValue()}
          </button>
        );
      },
    },
    {
      header: "Message",
      accessorKey: "description",
      cell: NACell,
    },
    {
      header: "Created",
      accessorKey: "timestamp",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {getValue()
                ? moment(getValue()).format("YY-MM-DD HH:mm:ss")
                : "N/A"}
            </p>
          </>
        );
      },
    },

    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <ClientAccessControl allowedPermissions={["can_edit_notifications"]}>
            <ActionModal
              handleDelete={handleDelete}
              handleRead={handleRead}
              row={row}
            />
          </ClientAccessControl>
        </>
      ),
    },
  ];

  return (
    <>
      <div className={tw`mt-10`}>
        <DataTable
          url={APIS.NOTIFICATION}
          queryKey={"notifications"}
          columns={defaultColumns}
          addNewPagePath={""}
          params={{
            deleted: false,
          }}
          tableName={"Notifications"}
        />
      </div>
    </>
  );
};

export default NotificationList;
